import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from 'reactstrap';

export default function SimplivLink({ pid, itemKey, onCopy }) {
  let simplivLink = '';

  if (pid === '606ecb9f46080b007db58dad') {
    simplivLink = 'https://www.simplivlearning.com/python/python-1200-practice-for-beginners';
  }
  if (pid === '606ecc55f09b240076caa778') {
    simplivLink = 'https://www.simplivlearning.com/python/python-programming-tutorials-for-beginners';
  }
  if (pid === '606ecd74e4c38c007d1263fc' || pid === '606ece529c233e007d2bfb43') {
    simplivLink = 'https://www.simplivlearning.com/python/learn-python-in-a-day';
  }
  if (pid === '606ecf5f9c233e007d2bfb44') {
    simplivLink = 'https://www.simplivlearning.com/python/python-for-beginners-a-python-mega-course-with-10-projects';
  }
  if (pid === '606ece529c233e007d2bfb43') {
    simplivLink = 'https://www.simplivlearning.com/python/learn-python-from-basic-to-advance-with-projects-in-a-day';
  }
  if (pid === '606ec606b48d0b0076ad7461') {
    simplivLink = 'https://www.simplivlearning.com/finance/cryptocurrency-what-you-must-know';
  }
  if (pid === '606ec61ee4c38c007d1263d3') {
    simplivLink = 'https://www.simplivlearning.com/finance/cryptocurrency-wallets-investing-trading-masterclass';
  }
  if (pid === '606ec7f746080b007db58dac') {
    simplivLink = 'https://www.simplivlearning.com/finance/stock-trading-investing-technical-analysis-masterclass';
  }
  if (pid === '606ec979b48d0b0076ad7474') {
    simplivLink = 'https://www.simplivlearning.com/finance/mastering-day-trading-for-stock-market-beginners';
  }
  if (pid === '606eca48e4c38c007d1263f8') {
    simplivLink = 'https://www.simplivlearning.com/finance/forex-trading-how-to-win-trading-currencies-from-home';
  }

  if (!simplivLink) {
    return (
      <CopyToClipboard text={itemKey} onCopy={onCopy}>
        <Button color="primary">
          <FormattedMessage id="reveal-key.simpliv-link.copy" defaultMessage="Copy" />
        </Button>
      </CopyToClipboard>
    );
  }

  return (
    <CopyToClipboard text={itemKey} onCopy={onCopy}>
      <a href={simplivLink} alt="alt" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
        <FormattedMessage id="reveal-key.simpliv-link.copy-and-redeem" defaultMessage="Copy & Redeem" />
      </a>
    </CopyToClipboard>
  );
}

SimplivLink.propTypes = {
  pid: PropTypes.string,
  itemKey: PropTypes.string,
  onCopy: PropTypes.func,
};

SimplivLink.defaultProps = {
  pid: '',
  itemKey: '',
  onCopy: () => {},
};
